/* eslint-disable react/no-multi-comp */

import React from 'react';
import './insights.scss';

import connect from '@app/utils/connect';

import { useInsightsContext } from './InsightsContext';

import { Tabs, theme } from '@app/ui';

type InsightsProps = {
    filters: any;
};

const MetricsTabs = ({ filters }: InsightsProps) => {
    const [hoveredTab, setHoveredTab] = React.useState(null);

    const { compareMetric, setCompareMetric, setYAxis, yAxisMap } =
        useInsightsContext() as {
            compareMetric: string;
            setCompareMetric: (id: string) => void;
            setYAxis: (id: string) => void;
            yAxisMap: Record<string, { name: string; icon: string }>;
        };

    const hasCompareDates =
        filters.compareDates && !!filters.compareDates.dates;

    const {
        token: { colorPrimary },
    } = theme.useToken();

    const onChange = id => {
        setCompareMetric(id);
        setYAxis(id);
    };

    const compareMetricOptions = React.useMemo(
        () =>
            Object.entries(yAxisMap).map(([id, { name, icon }]) => {
                const isActive = compareMetric === id;
                const isHovered = hoveredTab === name;

                return {
                    key: id,
                    label: (
                        <div
                            onMouseEnter={() => setHoveredTab(name)}
                            onMouseLeave={() => setHoveredTab(null)}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 12,
                                fontSize: '14px',
                            }}
                        >
                            <i
                                className={`fa-light fa-${icon}`}
                                style={{
                                    color:
                                        isActive || isHovered
                                            ? colorPrimary
                                            : '#515252',
                                    width: 16,
                                    height: 16,
                                    fontSize: 16,
                                }}
                            />
                            {name}
                        </div>
                    ),
                };
            }),
        [yAxisMap, compareMetric, hoveredTab],
    );

    if (!hasCompareDates) return null;

    return (
        <Tabs
            style={{
                marginTop: 24,
            }}
            activeKey={compareMetric}
            items={compareMetricOptions}
            onChange={onChange}
        />
    );
};

export default connect(['filters', 'client'])(MetricsTabs);
